module.exports = __webpack_public_path__ + "static/media/2.21_preview.2c1d615d.png";